/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import memoize from 'lodash/memoize';
import memoizeOne, { type MemoizedFn } from 'memoize-one';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { getProductEditions } from '@jira/platform__utils-get-meta/src/utils/get-meta-product-editions/index.tsx';
import { getAssetEncoding } from '../../collector/asset-encoding.tsx';
import { getBuildVariant } from '../../collector/build-variant.tsx';
import { getBundlerVersion } from '../../collector/bundler-version.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customData = (): Record<string, any> => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const commonCustomData: Record<string, any> = {};
	const shard = getMeta('ajs-shard');
	if (shard !== null && shard !== '') {
		commonCustomData.shard = shard;
	}

	commonCustomData['jira:productEditions'] = getProductEditions();
	commonCustomData['network:assetEncoding'] = getAssetEncoding();

	const buildVariant = getBuildVariant();
	if (buildVariant) {
		commonCustomData['app:buildVariant'] = buildVariant;
	}

	const bundlerVersion = getBundlerVersion();
	if (bundlerVersion) {
		commonCustomData['app:bundlerVersion'] = bundlerVersion;
	}

	commonCustomData.httpProtocol =
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		performance
			.getEntriesByType('resource')
			// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
			.find(({ nextHopProtocol }) => !!nextHopProtocol)?.nextHopProtocol ?? 'unknown';

	return commonCustomData;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const newGetCustomData: (() => Record<string, any>) & import('lodash').MemoizedFunction =
	memoize(customData, () => true);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomData: MemoizedFn<() => Record<string, any>> = memoizeOne(customData);
